import { APPOINTMENT_FILTER_OPTIONS_ADMIN } from '../../../constants/settings';
import { useAppointmentListContext } from '../../../contexts/AppointmentListProvider';
import AcademiaFilterSelect from '../../CommonComps/Inputs/AcademiaFilterSelect';

const FilterAppointmentSection = () => {
  // integration of context hooks here
  const { setAppointmentType } = useAppointmentListContext();

  // handler function to switching appointment filter types declared here
  const handleFilterAppointments = (type: string) => {
    setAppointmentType(type);
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  // rendering filter appointment section component here
  return (
    <section className='flex items-center justify-center xl:justify-end bg-base-white shadow-academia-sm rounded-lg px-3 md:px-5 py-4'>
      <AcademiaFilterSelect
        options={APPOINTMENT_FILTER_OPTIONS_ADMIN}
        onChangeHandler={(type) => handleFilterAppointments(type.toLowerCase())}
        variant='dark'
      />
    </section>
  );
};

export default FilterAppointmentSection;
